import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import RenderDashboardVehicles from "./Renders/Vehicles/Vehicles";

function DashboardVehicles() {
  return (
    <ToastProvider>
      <Dashboard>
        <RenderDashboardVehicles />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default DashboardVehicles